import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import ServiceIcon1 from "../assets/icons/Our Services Icons/1.png";
import ServiceIcon2 from "../assets/icons/Our Services Icons/2.png";
import ServiceIcon3 from "../assets/icons/Our Services Icons/3.png";
import ServiceIcon4 from "../assets/icons/Our Services Icons/4.png";
import ServiceIcon5 from "../assets/icons/Our Services Icons/5.png";
import ServiceIcon6 from "../assets/icons/Our Services Icons/6.png";
import ServiceIcon7 from "../assets/icons/Our Services Icons/7.png";
import ServiceIcon8 from "../assets/icons/Our Services Icons/8.png";
import ServiceIcon9 from "../assets/icons/Our Services Icons/9.png";
import CampaignsIcon from "../assets/icons/3.png";

export const tileImageById = {
  "symptom-check": ServiceIcon1,
  consult: ServiceIcon2,
  orders: ServiceIcon3,
  labs: ServiceIcon4,
  wallet: ServiceIcon5,
  monitor: ServiceIcon6,
  records: ServiceIcon7,
  learn: ServiceIcon8,
  emergency: ServiceIcon9,
  campaigns: CampaignsIcon,
};

function QuickActions({ tiles }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        marginTop: 14,
        marginBottom: 14,
      }}
    >
      {/* Outer background (matches screenshot tone) */}
      <div
        style={{
          background: "var(--bg)",
          borderRadius: 28,
          padding: "10px 0",
        }}
      >
        {/* Scroll row */}
        <div
          className="scrollbar-hide"
          style={{
            display: "flex",
            gap: 10,
            padding: "0 12px",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            scrollSnapType: "x mandatory",
          }}
        >
          {tiles.map((t) => (
           <motion.div
  key={t.id}
  whileTap={{ scale: 0.94 }}
  transition={{ type: "spring", stiffness: 300, damping: 20 }}
  onClick={() => navigate(`/${t.route}`)}
  style={{
    width: 80,          // narrower
    height: 125,           // taller = more curve feel
    flex: "0 0 auto",

    background: "var(--surface)",

    // ✅ THIS is what makes it "curved"
    borderRadius: 999,     // full pill shape

    padding: "4px 8px 10px",

    display: "flex",
    border : "0.5px solid #e7dada",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",

    textAlign: "center",
    cursor: "pointer",

    scrollSnapAlign: "start",
  }}
>
  {/* Tile image (matches quick action cover images) */}
  <div
    style={{
      width: 57,
      height: 57,
      borderRadius: "50%",
      overflow: "hidden",
      display: "flex",
      marginTop: 7,
      marginBottom: 20,
      background: `${t.color}22`,
    }}
  >
    {tileImageById[t.id] ? (
      <img
        src={tileImageById[t.id]}
        alt={t.title}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    ) : (
      t.icon
    )}
  </div>

  {/* Title */}
  <span
    style={{
      width: "100%",
      padding: "0 6px",
      fontSize: 12,
      fontWeight: 500,
      color: "#2C2C2E",
      lineHeight: "16px",
      overflowWrap: "break-word",
    }}
  >
    {t.title}
  </span>
</motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default QuickActions;